module.exports = __webpack_public_path__ + "img/8.209e24d5.gif";